var $ = require('jquery');
window.jQuery = $;
window.$ = $;

require('bootstrap');

import React from 'react';
import ReactDOM from 'react-dom';
import { Router, Route, IndexRoute, browserHistory, createMemoryHistory } from 'react-router';
if (window.cordova) {
    window.HC_History = createMemoryHistory(location);
    window.HC_PG = true;
}
else {
    window.HC_History = browserHistory;
    window.HC_PG = false;
}

"use strict";

import ReisterGlobalFunctions from "./utils.js";
ReisterGlobalFunctions();

import Index from "./index.js";
import Due from "./dues/due.js";
import Checklists from "./checklists/checklists.js";
import Documents from "./documents.js";
import Reports from "./reports/ReportsPanel.js";
import Profile from "./profile.js";
import Users from "./administrate.js";
import ReactNav from "./navpanel.js";
import Error from "./error.js";
import FullReport from "./reports/FullReport.js";

import Feedback from "./feedback.js";
import ViewFeedback from "./viewfeedback.js";
import PaymentPlans from "./payments/payment_plans.js";
import Accounts from "./admins/accounts.js";
import RegisterPage from './admins/register.accounts';

var ReactMain = React.createClass({

    getInitialState: function() {
        return {currentPanel: 'ChecklistsPanel', text: '', isCorrectContext: this.chekInitialContext()};
    },

    chekInitialContext: function() {
        var session = HC_GetSession();
        var subscribeSetting = HC_GetSetting("HC_IsSubscribed");
        var isCorrectContext = !(session && !subscribeSetting);
        if (!isCorrectContext)
            HC_SendRequest("login", {session_id: session}, function(reply){HC_SetLoginSettings(reply); this.setState({isCorrectContext:true})}.bind(this), null);
        return isCorrectContext;
    },

    componentDidMount: function () {
        document.cookie = "hc_session_id=" + HC_GetSession();
        HC_SubscribeHammerEvent(document.getElementById('navOverlay'), "swipeleft", HC_RestoreNavPanel);
    },
    updateAll: function () {
        this.forceUpdate();
    },

    render: function() {
        window.HC_UpdateAll = this.updateAll;
        if (window.HC_LastError)
            return (<Error/>);
        else if (location.pathname.toLowerCase().indexOf('error') >= 0) {
            location.assign('/');
            return (<div></div>);
        }

        if (!this.state.isCorrectContext)
            return (<div></div>);

        const nav = HC_GetSession() ? (<ReactNav/>) : null;

        return (
            <div id="react-main" style={{height: "100%"}}>
                {nav}
                <div id="react-content" style={{top:0, width: (nav ? '' : '100%')}} onClick={HC_RestoreNavPanel}>
                    {this.props.children}
                    <div id="navOverlay" style={{position: 'absolute',top: 0,bottom: 0,right: 0,left: 0,backgroundColor: 'rgba(255,255,255,0.5)',zIndex: 9998}}/>
                    <div id="hc-shield" className="hc-hide" onClick={HC_IgnoreClickEvent}style={{position: 'fixed',top: 0,bottom: 0,right: 0,left: 0,background: 'transparent',zIndex: 9999}}/>
                </div>
                {window.HC_Modal}
            </div>
        );
    }
});

function RenderRouter() {
    ReactDOM.render((
        <Router history={window.HC_History}>
            <Route path="/" component={ReactMain}>
                <IndexRoute component={Index}/>
                <Route path="due" component={Due}/>
                <Route path="checklists" component={Checklists}/>
                <Route path="documents" component={Documents }/>
                <Route path="reports" component={Reports}/>
                <Route path="/report/:link" component={FullReport}/>
                <Route path="profile" component={Profile}/>
                <Route path="users" component={Users}/>
                <Route path="feedback" component={Feedback}/>
                <Route path="payment_plans" component={PaymentPlans}/>
                <Route path="accounts" component={Accounts}/>
                <Route path="view_feedback" component={ViewFeedback}/>
                <Route path="register-new-accounts" component={RegisterPage}/>
                <Route path="error" component={Index}/>
            </Route>
        </Router>
    ), document.getElementById('react-div'));
}

import LoadLocalization from "./localization.js";
LoadLocalization(RenderRouter);


// WEBPACK FOOTER //
// ./main.js